/**
 * @generated SignedSource<<28bf4a6d7b666a95d05aa88c76a324af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeploymentsFragment$data = {
  readonly buildType: ReadonlyArray<{
    readonly rawId: string | null;
  }> | null;
  readonly " $fragmentType": "DeploymentsFragment";
};
export type DeploymentsFragment$key = {
  readonly " $data"?: DeploymentsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeploymentsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeploymentsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BuildTypeRest",
      "kind": "LinkedField",
      "name": "buildType",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rawId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BuildTypes",
  "abstractKey": null
};

(node as any).hash = "3d4a85eafce1a71509a6a62fffcceabe";

export default node;
